import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { useSetTheme, useThemeMode } from "contexts/theme-context";
import { ConfigProvider, Segmented } from "antd";
import colors from "constants/colors";

export const ThemeToggle = () => {
  const setTheme = useSetTheme();
  const theme: string = useThemeMode();

  return (
    <ConfigProvider
      theme={{
        components: {
          Segmented: {
            trackBg: "transparent",
            itemColor: colors.textGray,
            itemHoverBg: "transparent",
            itemHoverColor: colors.gray,
            itemActiveBg: "transparent",
            itemSelectedBg: "transparent",
            itemSelectedColor: colors.secondary,
            motionDurationMid: "0.0001s",
            motionDurationSlow: "0.0001s",
          },
        },
      }}
    >
      <Segmented
        styles={{
          item: {
            transition: "none",
          },
        }}
        size="large"
        value={theme}
        onChange={value => setTheme(value as "light" | "dark", true)}
        options={[
          { value: "light", icon: <FontAwesomeIcon icon={faSun} /> },
          { value: "dark", icon: <FontAwesomeIcon icon={faMoon} /> },
        ]}
      />
    </ConfigProvider>
  );
};
